import {
  arbitrum,
  avalanche,
  avalancheFuji,
  base,
  bsc,
  coreDao,
  fraxtal,
  immutableZkEvm,
  injective,
  ink,
  mainnet,
  mantle,
  monad,
  monadTestnet,
  plumeMainnet,
  polygon,
  sepolia,
  sonic,
} from "viem/chains";

import { isProduction } from "@/lib/utils/env";

import { solana, sui } from "./other-chain-details";

const TESTNETS: number[] = [...(isProduction() ? [] : [avalancheFuji.id, monadTestnet.id, sepolia.id])];

const MINT_CONNECTIONS: number[] = [
  mainnet.id,
  monad.id,
  avalanche.id,
  polygon.id,
  solana.id,
  arbitrum.id,
  base.id,
  immutableZkEvm.id,
  ink.id,
  sonic.id,
  ...TESTNETS,
];

const REDEEM_CONNECTIONS: number[] = [...MINT_CONNECTIONS];

// Admin list - all chains with swap contracts (for management)
const SWAP_ADMIN_CHAINS: number[] = [mainnet.id, monad.id, avalanche.id, polygon.id, bsc.id, ...TESTNETS];

// User-facing list - only chains ready for customer release
const SWAP_USER_CHAINS: number[] = [mainnet.id, monad.id, avalanche.id, polygon.id, ...TESTNETS];

// Keep SWAP_MINT/SWAP_REDEEM pointing to user list for ProductFeatures compatibility
const SWAP_MINT: number[] = [...SWAP_USER_CHAINS];
const SWAP_REDEEM: number[] = [...SWAP_USER_CHAINS];

const CROSS_CHAIN: number[] = [mainnet.id, avalanche.id, ...TESTNETS];

const RECIPIENT_ADDRESSES: number[] = [...MINT_CONNECTIONS];

const ATLAS_ADDRESSES: number[] = [mainnet.id, monad.id, avalanche.id, polygon.id, ...TESTNETS];

const INSTANT_LIQUIDITY_AND_RECIPIENT_ADDRESSES: number[] = [...ATLAS_ADDRESSES, ...RECIPIENT_ADDRESSES];

// Removed chains for network update phase 0, referenced in the sidebar "Network update" banner.
export const NETWORK_UPDATE_PHASE_0_BLOCKED_CHAINS: number[] = [
  bsc.id,
  coreDao.id,
  sui.id,
  mantle.id,
  fraxtal.id,
  plumeMainnet.id,
];

// Superset of chain IDs that must not receive new address additions: Injective (blocked after launch)
// plus NETWORK_UPDATE_PHASE_0_BLOCKED_CHAINS (“network update phase 0”). Existing saved addresses on these
// chains may still be shown in the UI.
export const ALL_BLOCKED_CHAINS: number[] = [...NETWORK_UPDATE_PHASE_0_BLOCKED_CHAINS, injective.id];

export const CHAIN_SUPPORT_LIST = {
  ATLAS_ADDRESSES: ATLAS_ADDRESSES,
  CROSS_CHAIN: CROSS_CHAIN,
  INSTANT_LIQUIDITY_AND_RECIPIENT_ADDRESSES: INSTANT_LIQUIDITY_AND_RECIPIENT_ADDRESSES,
  MINT_CONNECTIONS: MINT_CONNECTIONS,
  RECIPIENT_ADDRESSES: RECIPIENT_ADDRESSES,
  REDEEM_CONNECTIONS: REDEEM_CONNECTIONS,
  SWAP_ADMIN_CHAINS: SWAP_ADMIN_CHAINS,
  SWAP_MINT: SWAP_MINT,
  SWAP_REDEEM: SWAP_REDEEM,
} as const;

export type ProductFeatures = keyof typeof CHAIN_SUPPORT_LIST;
